import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import { useAirtable } from "../hooks/useAirtable";
import { useIframe } from "../hooks/useIframe";
import { useMediaQuery } from "react-responsive";

function RegisterResult({ mode, category, name, password, domain }) {
  const isMobile = useMediaQuery({ maxWidth: 820 });

  const [dataState, setDataState] = useState({});
  const [dataId, setDataId] = useState("");
  const [title, setTitle] = useState("개인참가");
  const { fetchData } = useAirtable(category);
  const { setMoveUrl } = useIframe(domain);

  useEffect(() => {
    setTitle(
      category === "individual"
        ? "개인참가"
        : category === "group"
        ? "단체참가"
        : category === "club"
        ? "대항전참가"
        : "개인참가"
    );
    const fetchDataAndSetData = async () => {
      const { fields, id } = await fetchData(
        `AND({name}="${name}", {password}="${password}")`
      );
      setDataState(fields);
      setDataId(id);
    };

    fetchDataAndSetData();
  }, []);

  const handleOnClick = () => {
    setMoveUrl(`${domain}`);
  };

  return (
    <Container ismobile={isMobile}>
      <Title>
        {title} <b>신청결과</b>
      </Title>
      <SubTitle>{name}님의 참가신청 내용입니다</SubTitle>
      <ContentContainer>
        <p>
          참가 종목은 <b>{dataState.event}코스</b>
          이며, <br />
          <b>{name}님</b>의 참가비는 <b>30,000원</b>
          입니다.
          <br /> 참가비 입금계좌는{" "}
          <b>신협은행 134-005-172599 예금주(나주육상연맹)</b>
          입니다. <br /> <br /> 확인후 빠른시일안에 처리해 드리겠습니다. <br />{" "}
          감사합니다.
          <br />
          <br /> ※ 입금시 본인 확인을 위해 입금자명에 본인이름과 생년월일을
          반드시 기입해 주십시오. 예 - 홍길동(720324)
        </p>
      </ContentContainer>
      <FormBtn primary={true} onClick={handleOnClick}>
        홈으로
      </FormBtn>
    </Container>
  );
}

export default RegisterResult;

const Container = styled.div`
  width: ${(props) => (props.ismobile ? "90%" : "82%")};
  margin: 0 auto;
  padding: 5rem 0;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;
const Title = styled.div`
  color: #555;
  font-family: "Jalnan", sans-serif;
  font-size: 4rem;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: -0.8px;
  & b {
    color: #ff791a;
  }
`;
const SubTitle = styled.div`
  font-size: 2rem;
  font-style: normal;
  font-weight: 800;
  line-height: 100%;
  letter-spacing: -0.8px;
  margin: 6rem 0 3rem;
  & b {
    color: #ff791a;
  }
`;
const ContentContainer = styled.div`
  width: 100%;
  border-radius: 1.5rem;
  border: 3px solid #d9d9d9;
  padding: 3rem;
  margin-bottom: 6rem;
  & p {
    margin: 0;
    letter-spacing: -0.5px;
    font-size: 1.7rem;
    line-height: 190%;
  }
  & b {
    font-weight: 700;
    color: #ff791a;
  }
`;
const FormBtn = styled.div`
  width: 50%;
  padding: 2rem;
  font-size: 1.9rem;
  font-weight: 700;
  background: #fff;
  border-radius: 100px 100px 100px 0px;
  border: 1.5px solid #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin: 0 auto;
  cursor: pointer;
  ${(props) =>
    props.primary &&
    css`
      background: #ff791a;
      color: #fff;
    `}
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #d9d9d9;
`;
